<!-- Main Content Area -->
  <div class="capture-container" [class.compact-capture]="isCompactCapture">
  <div class="main-content">
    <div *ngIf="isBusy"><h2>SAVING SWING</h2></div>
    <div class="video-container">
      <div class="video-wrapper face-on-wrapper">
        <div class="video-controls">
          <label class="video-label">Face-On Camera</label>
          <select 
            class="video-select" 
            [(ngModel)]="selectedFaceOnCamera"
            (change)="selectFaceOnCamera()">
            <option value="">Select Camera</option>
            <option *ngFor="let camera of availableCameras" [value]="camera.value">
              {{camera.label}}
            </option>
          </select>
        </div>
        <div class="video-content">
          <video #faceOnVideo autoplay playsinline muted webkit-playsinline>
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      <div class="video-wrapper dtl-wrapper">
        <div class="video-controls">
          <label class="video-label">{{ isCompactCapture ? 'Phone Camera (Down the Line)' : 'Down-The-Line Camera' }}</label>
          <select 
            class="video-select" 
            [(ngModel)]="selectedDownTheLineCamera"
            (change)="selectDownTheLineCamera()">
            <option value="">Select Camera</option>
            <option *ngIf="isCompactCapture" value="phone-rear">Rear camera</option>
            <option *ngFor="let camera of availableCameras" [value]="camera.value">
              {{camera.label}}
            </option>
          </select>
        </div>
        <div class="video-content">
          <video #downTheLineVideo autoplay playsinline muted webkit-playsinline>
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
    
    <!-- Control Bar -->
    <div class="control-bar">
      <button class="btn" (click)="backButtonClicked()">
        &lt; Back to Session
      </button>
      <button 
        class="record-btn" 
        [class.recording]="isRecording"
        (click)="toggleRecording()">
        <div class="record-icon"></div>
      </button>
      
      <div class="control-options">
        <div class="control-group">
          <label class="control-label">Record Delay</label>
          <select 
            class="control-select" 
            [(ngModel)]="recordDelay"
            (change)="updateRecordDelay()">
            <option value="0">0 second</option>
            <option value="8">8 seconds</option>
            <option value="15">15 seconds</option>
            <option value="30">30 seconds</option>
          </select>
        </div>
        
        <div class="control-group">
          <label class="control-label">Auto Stop After</label>
          <select 
            class="control-select" 
            [(ngModel)]="autoStopAfter"
            (change)="updateAutoStop()">
            <option value="5">5 seconds</option>
            <option value="8">8 seconds</option>
            <option value="15">15 seconds</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  </div>
